/* icon set (line icons, currentColor) + llama mascot */
import React from "react";
import { resources } from "../resources.js";

const GD_PATHS = {
  arrowRight: (
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12h15" /><path d="M13 6l6 6-6 6" />
    </g>
  ),
  arrowLeft: (
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 12H5" /><path d="M11 6l-6 6 6 6" />
    </g>
  ),
  chevron: (
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 6l6 6-6 6" />
    </g>
  ),
  chevronDown: (
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </g>
  ),
  check: (
    <g fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12.5l4.5 4.5L19 6.5" />
    </g>
  ),
  plus: (
    <g fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M12 5v14M5 12h14" />
    </g>
  ),
  minus: (
    <g fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M5 12h14" />
    </g>
  ),
  close: (
    <g fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
      <path d="M6 6l12 12M18 6L6 18" />
    </g>
  ),
  lock: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
    </g>
  ),
  shield: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z" /><path d="M9 12l2 2 4-4" />
    </g>
  ),
  bank: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-5 9 5" /><path d="M5 9v9M9 9v9M15 9v9M19 9v9" /><path d="M3 21h18" />
    </g>
  ),
  search: (
    <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="6" /><path d="M20 20l-4-4" />
    </g>
  ),
  pin: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11z" /><circle cx="12" cy="10" r="2.5" />
    </g>
  ),
  user: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="3.6" /><path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6" />
    </g>
  ),
  phone: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3h3l1.6 5-2 1.4a12 12 0 0 0 5 5l1.4-2 5 1.6v3a2 2 0 0 1-2.2 2A16 16 0 0 1 4 5.2 2 2 0 0 1 6 3z" />
    </g>
  ),
  mail: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="M4 7l8 6 8-6" />
    </g>
  ),
  calendar: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="5" width="16" height="16" rx="2.5" /><path d="M4 9h16M8 3v4M16 3v4" />
    </g>
  ),
  edit: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20h4L19 9l-4-4L4 16z" /><path d="M14 6l4 4" />
    </g>
  ),
  spark: (
    <g fill="currentColor">
      <path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z" />
    </g>
  ),
  id: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <circle cx="8.5" cy="11" r="2.1" />
      <path d="M5.5 16.2c.5-1.6 1.7-2.4 3-2.4s2.5.8 3 2.4" />
      <path d="M14.5 9.5H18M14.5 12.5H18M14.5 15.3h2.4" />
    </g>
  ),
  info: (
    <g fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="8.5" /><path d="M12 11v5M12 8h.01" />
    </g>
  ),
  /* vehicles */
  car: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 13l1.8-4.4A3 3 0 0 1 7.6 7h8.8a3 3 0 0 1 2.8 1.6L21 13" />
      <path d="M3 13h18v4a1 1 0 0 1-1 1h-1.5M5.5 18H4a1 1 0 0 1-1-1v-4" />
      <circle cx="7.5" cy="18" r="1.9" /><circle cx="16.5" cy="18" r="1.9" />
    </g>
  ),
  ute: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 14l1.4-4A2.5 2.5 0 0 1 5.8 8h4l1.5 4H22" />
      <path d="M2 14h20v3a1 1 0 0 1-1 1h-1M5 18H3a1 1 0 0 1-1-1v-3" />
      <circle cx="7" cy="18" r="1.9" /><circle cx="17.5" cy="18" r="1.9" />
    </g>
  ),
  suv: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 13V9.5A2.5 2.5 0 0 1 5.5 7h11a2.5 2.5 0 0 1 2 1l3 5" />
      <path d="M3 13h18.5v4a1 1 0 0 1-1 1H19M5 18H4a1 1 0 0 1-1-1v-4M12 7v6" />
      <circle cx="7.5" cy="18" r="1.9" /><circle cx="16.5" cy="18" r="1.9" />
    </g>
  ),
  bike: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="5.5" cy="16" r="3.3" /><circle cx="18.5" cy="16" r="3.3" />
      <path d="M5.5 16l3.5-6h4l2.5 4M9 10h4M16 12l2-4h2" />
    </g>
  ),
  /* marital */
  ring: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 4h6l2 3-5 5-5-5z" /><circle cx="12" cy="16" r="4" />
    </g>
  ),
  heart: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20s-7-4.4-7-9.5A3.8 3.8 0 0 1 12 7a3.8 3.8 0 0 1 7-1.5C19 10.6 12 20 12 20z" />
    </g>
  ),
  users: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="8" r="3" /><path d="M3 19c0-3 2.7-5 6-5s6 2 6 5" /><path d="M16 6a3 3 0 0 1 0 6M21 19c0-2.4-1.4-4-4-4.5" />
    </g>
  ),
  home: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 11l8-6 8 6" /><path d="M6 10v9h12v-9" />
    </g>
  ),
  cart: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 4h2l2.2 11h10l2-8H6" /><circle cx="9" cy="19" r="1.4" /><circle cx="17" cy="19" r="1.4" />
    </g>
  ),
  doc: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 3h8l4 4v14H6z" /><path d="M14 3v4h4M9 13h6M9 17h6" />
    </g>
  ),
  scale: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 4v16M6 7h12M6 7l-3 6h6zM18 7l3 6h-6z" /><path d="M8 20h8" />
    </g>
  ),
  briefcase: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="8" width="18" height="12" rx="2.5" /><path d="M8 8V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 13h18" />
    </g>
  ),
  wallet: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="6" width="18" height="13" rx="2.5" /><path d="M3 10h18M16 14h2" />
    </g>
  ),
  trend: (
    <g fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 16l5-5 3 3 7-7" /><path d="M16 7h4v4" />
    </g>
  ),
};

export function Icon({ name, size = 22, style = {} }) {
  const p = GD_PATHS[name];
  if (!p) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" style={{ display: "block", ...style }} aria-hidden="true">
      {p}
    </svg>
  );
}

/* Brand mascot (placeholder SVG — swap via resources.js / mascotUrl option) */
export function Llama({ size = 120 }) {
  if (!resources.mascot) return null;   // a brand without its own character shows none
  return (
    <img src={resources.mascot} alt="Mascot" width={size}
      style={{ width: size, height: "auto", display: "block", userSelect: "none", pointerEvents: "none" }} />
  );
}

export { GD_PATHS };
